<template functional>
  <div
    class="chat-footer"
    :class="{ open: props.isOpen }"
    @click="listeners.click"
  >
    <img
      v-if="props.isOpen"
      src="../../assets/eb-l-chatbot-arrows-close-selected.png"
      class="arrow"
    >
    <img
      v-else
      src="../../assets/eb-l-chatbot-arrows-open-selected.png"
      class="arrow"
    >
  </div>
</template>

<script>
export default {
  name: 'ChatFooter',

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="postcss" scoped>
.chat-footer {
  width: 393px;
  height: 55px;
  background: url('../../assets/chat-border-short-copy-5.png') no-repeat;
  background-size: contain;
  @apply cursor-pointer pl-32;

  &.open {
   background-size: cover;
  }
}

.arrow {
  opacity: 0.3;
  @apply pr-16  py-4;

  &:hover {
    opacity: 1;
  }
}
</style>
